import axios from 'axios';
import { stringify } from 'qs';
import { ErrorUtil } from '../index';
export const getParamSerializerForAxiosVersion1or0 = () => {
    const serializer = (params) => stringify(params, { arrayFormat: 'repeat' });
    return axios.VERSION.startsWith('0.') ? serializer : { serialize: serializer };
};
const API = axios.create({
    timeout: 10000,
    paramsSerializer: getParamSerializerForAxiosVersion1or0(),
});
class SingleConcurrentRequestController {
    constructor() {
        Object.defineProperty(this, "controller", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: typeof AbortController !== 'undefined' && new AbortController()
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url, config) => {
                var _a;
                this.cancelPreviousRequests();
                try {
                    const response = await API.get(url, { ...config, signal: (_a = this.controller) === null || _a === void 0 ? void 0 : _a.signal });
                    return response.data;
                }
                catch (e) {
                    this.handleErrors(e);
                }
            }
        });
        Object.defineProperty(this, "put", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url, data, config) => {
                var _a;
                this.cancelPreviousRequests();
                try {
                    return await API.put(url, data, { ...config, signal: (_a = this.controller) === null || _a === void 0 ? void 0 : _a.signal });
                }
                catch (e) {
                    this.handleErrors(e);
                }
            }
        });
        Object.defineProperty(this, "post", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url, data, config) => {
                var _a;
                this.cancelPreviousRequests();
                try {
                    return await API.post(url, data, { ...config, signal: (_a = this.controller) === null || _a === void 0 ? void 0 : _a.signal });
                }
                catch (e) {
                    this.handleErrors(e);
                }
            }
        });
        Object.defineProperty(this, "delete", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (url, config) => {
                var _a;
                this.cancelPreviousRequests();
                try {
                    return await API.delete(url, { ...config, signal: (_a = this.controller) === null || _a === void 0 ? void 0 : _a.signal });
                }
                catch (e) {
                    this.handleErrors(e);
                }
            }
        });
        Object.defineProperty(this, "cancelPreviousRequests", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (this.controller) {
                    this.controller.abort('canceled');
                    this.controller = new AbortController();
                }
            }
        });
        Object.defineProperty(this, "handleErrors", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                if (!this.isCancel(e)) {
                    ErrorUtil.pushErrorToTeliaRum(e);
                    console.error(e);
                }
                throw e;
            }
        });
        Object.defineProperty(this, "isCancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e) => {
                var _a, _b, _c;
                const isAbortByBrowser = (e === null || e === void 0 ? void 0 : e.code) === 'ECONNABORTED' && ((_a = e === null || e === void 0 ? void 0 : e.message) === null || _a === void 0 ? void 0 : _a.includes('Request aborted'));
                const mightBeSafariBrowserCancelError = ((_b = navigator.vendor) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes('apple')) && (e === null || e === void 0 ? void 0 : e.code) === 'ERR_NETWORK' && ((_c = e === null || e === void 0 ? void 0 : e.message) === null || _c === void 0 ? void 0 : _c.includes('Network Error'));
                return (e === null || e === void 0 ? void 0 : e.name) === 'AbortError' || isAbortByBrowser || (e === null || e === void 0 ? void 0 : e.message) === 'canceled' || mightBeSafariBrowserCancelError;
            }
        });
    }
}
export { API, SingleConcurrentRequestController };
//# sourceMappingURL=ApiUtil.js.map